import { BASE_FRONT_END_URL, getApprovalMaxClientId } from '@/constants/constant';

export const authorizeApprovalMax = () => {
	const clientId = getApprovalMaxClientId();
	const redirectUri = BASE_FRONT_END_URL + '/materials/approval-max/authorization';
	const scope =
		'https://www.approvalmax.com/scopes/public_api/write https://www.approvalmax.com/scopes/public_api/read offline_access';
	const responseType = 'code';

	return `https://identity.approvalmax.com/connect/authorize?response_type=${responseType}&client_id=${clientId}&scope=${scope}&redirect_uri=${redirectUri}`;
};
